import { Theme } from "@mui/system";
export const secondaryStyles = (
  type: string,
  theme: Theme,
  multi = false,
  date = false
) => {
  const multiStyle = multi
    ? {
        ".MuiSelect-multiple": {
          background: `${theme.palette.background.default} !important`,
        },
      }
    : {};
  return type === "secondary"
    ? {
        backgroundColor:
          !date && `${theme.palette.background.default} !important`,
        ".MuiOutlinedInput-notchedOutline": {},
        ".MuiOutlinedInput-input": {
          backgroundColor: `${theme.palette.background.default} !important`,
        },
        ".MuiInputBase-root": {
          backgroundColor: `${theme.palette.background.default} !important`,
        },
        "input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus":
          {
            WebkitBoxShadow: `0 0 0px 1000px ${
              theme.palette.mode === "light"
                ? theme.palette.background.default
                : "#2b2b2b"
            } inset !important`,
          },
        ...multiStyle,
      }
    : {};
};
